import { Footer as StyledFooter } from './styles';
import Logo from '../../assets/logo.svg';

function Footer() {
  return (
    <StyledFooter>
      <img src={Logo} alt="Logo gazin" />
    </StyledFooter>
  );
}

export default Footer;
